import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const maneuversModule = namespace('maneuvers');
let CharactersManeuvers = class CharactersManeuvers extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Maneuvers';
    }
    created() {
        this.fetchManeuvers();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        return _(this.maneuvers)
            .map(maneuver => ({
            ...maneuver,
            id: maneuver.name,
            isExpandable: maneuver.description
        })).value();
    }
    get headers() {
        return [
            { text: 'Name', value: 'name' },
            {
                text: 'Type',
                value: 'type',
                render: _.startCase,
                filterChoices: ['General', 'Mental', 'Physical'],
                filterFunction: ({ type }, filterValue) => _.startCase(type) === filterValue
            },
            {
                text: 'Prerequisite',
                value: 'prerequisite',
                render: (prerequisite) => prerequisite ? 'Yes' : 'No',
                filterChoices: ['Yes', 'No'],
                filterFunction: ({ prerequisite }, filterValue) => (prerequisite ? 'Yes' : 'No') === filterValue
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    maneuversModule.State
], CharactersManeuvers.prototype, "maneuvers", void 0);
__decorate([
    maneuversModule.Action
], CharactersManeuvers.prototype, "fetchManeuvers", void 0);
CharactersManeuvers = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], CharactersManeuvers);
export default CharactersManeuvers;
